import React, { useContext, useEffect, useMemo } from 'react';
import { SectionTitle } from 'components/SectionTitle';
import { DataContext } from 'Contexts/DataContext';
import { USER_ROLES } from 'constant';
import { generateQuickStartStyles } from 'sections/QuickStart/QuickStartStyles';
import { Box } from '@mui/material';
import { ReactComponent as RocketIcon } from './icons/rocket.svg';
import { ReactComponent as FAQIcon } from './icons/faq.svg';
import { ReactComponent as GlossaryIcon } from './icons/glossary.svg';
import { Card } from './Card';

const guidesIds = {
    gettingStarted: 'getting-started',
    faq: 'faq',
    glossary: 'glossary',
    api: 'api',
};

const roleUrls = {
    [guidesIds.gettingStarted]: {
        [USER_ROLES.ASSET_MANAGEMENT]: '/General/Getting Started - Asset Management',
        [USER_ROLES.SHIPMENT_MANAGEMENT]: '/General/Getting Started - Shipment Management',
    },
    [guidesIds.faq]: {
        [USER_ROLES.ASSET_MANAGEMENT]: '/General/FAQ - Asset Management',
        [USER_ROLES.SHIPMENT_MANAGEMENT]: '/General/FAQ - Shipment Management',
    },
    [guidesIds.glossary]: {
        [USER_ROLES.ASSET_MANAGEMENT]: '/General/Glossary - Asset Management',
        [USER_ROLES.SHIPMENT_MANAGEMENT]: '/General/Glossary - Shipment Management',
    },
    [guidesIds.api]: {
        [USER_ROLES.ASSET_MANAGEMENT]: '/API/',
        [USER_ROLES.SHIPMENT_MANAGEMENT]: '/API/',
    },
};

const guides = [
    {
        id: guidesIds.gettingStarted,
        title: 'Quickstart Guides',
        description: 'Everything you need to know to start working with SECURE',
        icon: RocketIcon,
        url: 'not-found',
    },
    {
        id: guidesIds.faq,
        title: 'FAQ',
        description: 'Get answers to the most frequently asked questions',
        icon: FAQIcon,
        url: 'not-found',
    },
    {
        id: guidesIds.glossary,
        title: 'Glossary',
        description: 'Get familiar with commonly used terms',
        icon: GlossaryIcon,
        url: 'not-found',
    },
];

const setRoleUrl = (userRoles: string[], role: string) => {
    if (userRoles.includes(role)) {
        guides.forEach((guide) => {
            const roleUrl = roleUrls[guide.id][role];

            if (roleUrl) {
                guide.url = roleUrl;
            }
        });
    }
};

export function QuickStart() {
    const { userRoles } = useContext(DataContext);
    const styles = useMemo(() => generateQuickStartStyles(), []);

    useEffect(() => {
        if (userRoles.includes(USER_ROLES.ASSET_MANAGEMENT)) {
            setRoleUrl(userRoles, USER_ROLES.ASSET_MANAGEMENT);
        } else if (userRoles.includes(USER_ROLES.SHIPMENT_MANAGEMENT)) {
            setRoleUrl(userRoles, USER_ROLES.SHIPMENT_MANAGEMENT);
        }
    }, [userRoles]);

    return (
        <Box component="section" sx={styles.wrapper}>
            <SectionTitle title="Quickstart Guides" sx={styles.title} />

            <Box sx={styles.cards}>
                {guides.map((guide) => (<Card key={guide.id} {...guide} />))}
            </Box>
        </Box>
    );
}
